<template>
  <div class="login">
    <div class="pc_login">
      <div class='loginmask'></div>
      <div class='reset-mask' :class="{'show-modal':login_show}"  v-show="!reg_show&&!forget_show">
        <div class='reset-main'>
          <div class="login_title">
            <p>账号登录</p>
            <span id='close' class='closeico' @click='loginShow()'></span>
          </div>
          <div class="game-tab-home">
            <div
              class="game-tab-item"
              :class="{'active': currentLoginMode === LoginModeEnum.WSY}"
               @click="changeCurrentLoginMode(LoginModeEnum.WSY)"
              style="margin-left:119px;"
            >
              <div class="game-icon wsy"></div>
              <div class="game-name">叫我万岁爷</div>
            </div>
            <div
              class="game-tab-item"
              :class="{'active': currentLoginMode === LoginModeEnum.DQ}"
              @click="changeCurrentLoginMode(LoginModeEnum.DQ)"
              style="margin-right:105px;"
            >
              <div class="game-icon dq"></div>
              <div class="game-name">我在大清当皇帝</div>
            </div>
          </div>

          <div class="wsy-login" v-if="isWSY">
            <div class="login-way-tab-home">
              <div class="login-way-tab-item" :class="{'active': currentWSYLoginType === WsyLoginTypeEnum.Account}" @click="changeCurrentWSYLoginType(WsyLoginTypeEnum.Account)" >账户登录</div>
              <div class="login-way-tab-item" :class="{'active': currentWSYLoginType === WsyLoginTypeEnum.PhoneCode}" @click="changeCurrentWSYLoginType(WsyLoginTypeEnum.PhoneCode)" style="margin: 0 20px;">手机验证码登录</div>
              <div class="login-way-tab-item" :class="{'active': currentWSYLoginType === WsyLoginTypeEnum.VerificationCode}" @click="changeCurrentWSYLoginType(WsyLoginTypeEnum.VerificationCode)" >角色验证码登录</div>
            </div>

            <AccountLoginForm v-if="currentWSYLoginType === WsyLoginTypeEnum.Account" :hiddenFooter="true"  @loading="l => loading = l" />
            <VerificationCodeLoginForm
              v-if="currentWSYLoginType === WsyLoginTypeEnum.VerificationCode"
              @loading="l => loading = l"
            />
            <PhoneCodeForm v-if="currentWSYLoginType === WsyLoginTypeEnum.PhoneCode" :hiddenFooter="true"  @loading="l => loading = l" />

          </div>
          <AccountLoginForm v-if="isDQ" @loading="l => loading = l" />
        </div>
      </div>
    </div>
    <Register v-show="reg_show"></Register>
    <GetBackPwd v-show="forget_show"></GetBackPwd>
    <Loading v-if='loading'></Loading>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Loading from './loading'
import Register from './Register'
import GetBackPwd from '../getBack/GetBackPwd'

import AccountLoginForm from './AccountLoginForm.vue'
import PhoneCodeForm from './PhoneCodeForm.vue'
import VerificationCodeLoginForm from './VerificationCodeLoginForm.vue'

const LoginModeEnum = {
  WSY: 0,
  DQ: 1
}

const WsyLoginTypeEnum = {
  Account: 0,
  VerificationCode: 1,
  PhoneCode: 2
}

export default {
  data () {
    return {
      loading: false,
      currentLoginMode: LoginModeEnum.WSY,
      LoginModeEnum: LoginModeEnum,
      currentWSYLoginType: WsyLoginTypeEnum.Account,
      WsyLoginTypeEnum
    }
  },
  components: {
    Loading,
    Register,
    GetBackPwd,
    AccountLoginForm,
    VerificationCodeLoginForm,
    PhoneCodeForm
  },
  computed: {
    ...mapGetters([
      'login_show',
      'reg_show',
      'forget_show'
    ]),
    isWSY () {
      return this.currentLoginMode === LoginModeEnum.WSY
    },
    isDQ () {
      return this.currentLoginMode === LoginModeEnum.DQ
    }
  },
  mounted () {
  },
  methods: {
    changeCurrentLoginMode (mode) {
      this.currentLoginMode = mode
    },
    changeCurrentWSYLoginType (mode) {
      this.currentWSYLoginType = mode
    },
    loginShow () {
      this.$store.dispatch('change_login_show', false)
      this.$store.dispatch('change_reg_show', false)
      this.$store.dispatch('change_forget_show', false)
      this.currentLoginMode = LoginModeEnum.DQ
      this.$nextTick(() => {
        this.currentLoginMode = LoginModeEnum.WSY
      })
      this.currentWSYLoginType = WsyLoginTypeEnum.Account
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.login{
  .loginmask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 14;
  }
  .reset-mask {
    width: 439px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -326px 0 0 -219px;
    z-index: 14;
    visibility: hidden;
    .reset-main {
      background: #fff;
      -webkit-transform: translateY(20%);
      transform: translateY(20%);
      opacity: 0;
      border-radius: 5px;
      .login_title{
        height: 86px;
        width: 100%;
        position: relative;
        p{
          width: 100%;
          line-height: 86px;
          letter-spacing: 3px;
          font-size: 28px;
          color: #fff;
          background:url("../../../static/img/common/login_header.png")no-repeat;
        }
        .closeico {
          position: absolute;
          right: 5px;
          top:10px;
          display: block;
          width: 41px;
          height: 40px;
          cursor: pointer;
          &:hover:before {
            -webkit-transform: rotate(-135deg);
            -ms-transform: rotate(-135deg);
            transform: rotate(-135deg);
          }
          &:hover:after {
            -webkit-transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
            transform: rotate(-45deg);
          }

          &:hover:before, &:hover:after {
            -webkit-transition: -webkit-transform .3s ease-out;
            transition: -webkit-transform .3s ease-out;
            transition: transform .3s ease-out;
            transition: transform .3s ease-out, -webkit-transform .3s ease-out;
          }
          &:before {
            -webkit-transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
            transform: rotate(-45deg);
          }
          &:after {
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
          }
          &:before, &:after {
            position: absolute;
            top: 28px;
            right: 12px;
            content: "";
            width: 27px;
            height: 2px;
            background: #fff;
            -webkit-transition: -webkit-transform 0.5s ease-out;
            transition: -webkit-transform 0.5s ease-out;
            transition: transform 0.5s ease-out;
            transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
          }
        }
      }
    }
  }
  .show-modal {
    visibility: visible;
    .reset-main {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
  }
}

.game-tab-home {
  display: flex;
  justify-content: space-between;
  margin-top: 29px;
  margin-bottom: 25px;
  .game-tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .game-icon {
      width: 64px;
      height: 64px;
      position: relative;
      &.wsy {
        background: url('../../../static/img/common/icon_wansuiye_pc.png') no-repeat;
      }
      &.dq {
        background: url('../../../static/img/common/icon_daqing_pc.png') no-repeat;
      }
      &::before {
        content: " ";
        width: 64px;
        height: 64px;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.6);
      }
    }
    .game-name {
      font-size: 16px;
      color: #535353;
      margin-top: 7px;
    }
    &.active {
      .game-icon::before {
        display: none;
      }
      .game-icon::after {
        content: " ";
        width: 26px;
        height: 26px;
        position: absolute;
        background: url('../../../static/img/common/icon_check_pc.png') no-repeat;
        right: 0;
        bottom: 0;
      }
    }
  }
}

.login-way-tab-home {
  display: flex;
  justify-content: center;
  margin-bottom: 33px;
  .login-way-tab-item {
    font-size: 18px;
    color: #535353;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    &.active {
      color: #ba0805;
      &::after {
        content: " ";
        width: 48px;
        height: 4px;
        border-radius: 4px;
        background-color: #ba0805;
        margin-top: 9px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Login.vue